import { Component, ElementRef, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { catchError, first, throwError } from 'rxjs';
import { CommonService } from 'src/app/services/common.service';
import { LoginService } from 'src/app/services/login.service';
import { UserService } from 'src/app/services/user.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { User } from 'src/app/models/user';
import { AutomationService } from 'src/app/services/automation.service';
import { ThisReceiver } from '@angular/compiler';
import { time } from 'highcharts';
import { SocketService } from 'src/app/services/socket.service';
import { ValidationService } from 'src/app/services/validation.service';
import { HttpErrorResponse } from '@angular/common/http';
import { error } from 'jquery';
import { AccessTokenService } from 'src/app/services/access-token.service';
import { NotifyUserUpdation } from 'src/app/services/notify-user-creation.service';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SearchPipe } from 'src/app/search.pipe';
import { NgxPaginationModule } from 'ngx-pagination';
import { PaginationComponent } from 'src/app/helpers/pagination/pagination.component';

class tmpEnv {
  userName: any;
  userEmail: any
  defaultGroupsNumber: any;
  defaultGroupsRepetitions: any;
  defaultGroupsDuration: any;
  defaultQuotasTooltip: string;
  password: any;
}
class removingFilter {
  groupOwner: any;
}
@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.css'],
  standalone: true,
  imports: [TranslateModule, CommonModule, FormsModule, SearchPipe, NgxPaginationModule, PaginationComponent]
})
export class UsersComponent implements OnInit {
  modalRef!: MatDialogRef<any>;
  @ViewChild('alerttemplate') alerttemplate!: TemplateRef<any>;
  @ViewChild('unblockedUser') unBlockedUser: TemplateRef<any>;
  @ViewChild('blockedUser') blockedUser: TemplateRef<any>;
  msg: string = "";

  @ViewChild('delete_user') removeTemplate: TemplateRef<any>;
  @ViewChild('delete_all_user') removeAllTemplate: TemplateRef<any>;
  @ViewChild('alert_message') alertTemplate: TemplateRef<any>;
  @ViewChild('created_User') crateUserTemplate: TemplateRef<any>
  @ViewChild('fliter') fliterRemoveUser: TemplateRef<any>
  @ViewChild('Duplicate_Password') DuplicatePassword: TemplateRef<any>

  @ViewChild('Duplicate_User') DuplicateUser: TemplateRef<any>

  @ViewChild('created_Password') createdPassword: TemplateRef<any>
  @ViewChild('ProfileStaus') template: TemplateRef<any>
  userEmail: any
  buttonColor: string = '#6d8f9d'
  selectUserEmail: any
  usersListByemail: any[] = [];
  removingFilters: any = new removingFilter();
  passwordByAdmin: string;
  findemail: any;

  // isDisabled :boolean =true;
  showPassword: boolean = false;
  keyName: any;
  tmpEnv: tmpEnv = new tmpEnv();
  userFields =
    'email,' +
    'name,' +
    'privilege,' +
    'groups.quotas'
    ;
  removingFilterOptions = ["True", "False", "Any"];
  confirmRemove = { value: true }
  nameRegex = /^[\w\s]+$/;
  nameRegexStr = '^[\\w\\s]+$';
  page = 1;
  userPerPageSize: any;
  userPerPageOptions = [
    { name: '1', value: 1 }
    , { name: '5', value: 5 }
    , { name: '10', value: 10 }
    , { name: '20', value: 20 }
    , { name: '50', value: 50 }
    , { name: '100', value: 100 }
    , { name: '200', value: 200 }
    , { name: '500', value: 500 }
    , { name: '1000', value: 1000 }
    , { name: '*', value: 0 }
  ];
  usersByEmail = {}
  currentUser: User;
  om: any
  users: any[] = []
  GroupsQuotas: boolean = false;
  isEmailValid = false;
  isNameValid = false;
  isPassword = false;
  isFormValid = false;
  saveButtonDisable: boolean = true;
  showCreateUser: boolean = false;
  showFilters: boolean = false;
  showDefaultGroupsQuotas: boolean = false;
  saveDefaultButtonDisable: boolean = true;
  userToBeRemoved: any;
  userToBeRemovedAll: any;
  alertMessage: any;
  userPageSize = 10;
  searchText: any;
  adminUser: any;
  filteredUsers: any
  userForm: any;
  search: any;
  _email: any;

  fieldTextType: boolean

  constructor(private userService: UserService,
    private commonservice: CommonService,
    private loginservice: LoginService,
    private dialog: MatDialog,
    private automationService: AutomationService,
    private socketService: SocketService,
    private elementRef: ElementRef,
    private accessTokenService: AccessTokenService,
    private notifyUserUpdation: NotifyUserUpdation

  ) {
    this.loginservice.currentUser.subscribe(X => this.currentUser = X);

  }

  ngOnInit(): void {
    this.initScope();
    this.userPerPageSize = 10;
    //Default filter value
    this.removingFilters.groupOwner = "Any";

    // this.CreateUser()


  }

  onSearch(searchData: any) {
    this.search = searchData;
    this.page = 1;
  }

  onItemPerPageChange(changedItemPerPage: any) {
    this.userPerPageSize = changedItemPerPage;
    this.page = 1;
  }

  onNextPageChange(nextPage: number) {
    this.page = nextPage;
  }

  // handlePageChange(event: any) {
  //   this.page = event.pageIndex + 1;        // Convert 0-based index to 1-based
  //   this.itemsPerPage = event.pageSize;     // Update page size if changed
  //   this.nextPageChange.emit(this.page);    // Emit event for parent component
  // }

  mailTo() {

    let mail = 'mailto:admin@apmosys.com'
    window.location.href = mail;
  }

  addUser(user: any, timeStamp: number) {


    return this.commonservice.add(
      this.users,
      this.usersByEmail,
      user,
      'email',
      timeStamp
    );
  }
  deleteUser(email, timeStamp) {

    return this.commonservice.delete(
      this.users
      , this.usersByEmail
      , email
      , timeStamp)

  }

  onChange(mail: any) {
    this.selectUserEmail = mail.target.value

  }


  //show users
  initScope() {
    this.userService.getOboeUsers(this.userFields, this.users).subscribe((response: any) => {
      //Need to check
      response.users.forEach((user) => {
        this.addUser(user, -1);
      })
      if (this.commonservice.isExisting(this.usersByEmail[this.currentUser.email])) {
        this.adminUser = this.users[this.usersByEmail[this.currentUser.email].index]
      }
    })
    this.confirmRemove
  }

  //for create users
  createUser() {
    this.userService.createUser(this.tmpEnv.userName, this.tmpEnv.userEmail, this.tmpEnv.password).pipe(first())
      .subscribe((res: any) => {
        if (res.description === 'Created (user)') {
          this.accessTokenService.generateAccessToken(this.keyName, this.tmpEnv.userEmail, this.tmpEnv.userName);
          this.tmpEnv.userName = '';
          this.tmpEnv.userEmail = '';
          this.tmpEnv.password = '';
          this.keyName = '';

          //  Hide the form after successful user creation
          this.showCreateUser = false;
        }

        this.addUser(res.user, -1);
        this.usersListByemail.push(res.user.email);

        // Notify other components that a user was created
        this.notifyUserUpdation.notifyUserCreated(res.user);

        this.modalRef = this.dialog.open(this.crateUserTemplate);
        setTimeout(() => {
          this.modalRef.close();;
        }, 2000);
      }, (error: HttpErrorResponse) => {
        if (error.error.description === 'User with the same mail already exists!') {
          this.modalRef = this.dialog.open(this.DuplicateUser);
          setTimeout(() => {
            this.modalRef.close();;
          }, 2000);
        }
      });
  }


  // SavePassword() {

  //   let x = document.getElementById(
  //     "mySelect");



  //   if (this.tmpEnv.password == undefined && this.selectUserEmail == undefined) {
  //     alert("Please fill the details!")
  //   }
  //   else if (this.tmpEnv.password == undefined || this.selectUserEmail == undefined) {
  //     if (this.tmpEnv.password == undefined) {
  //       alert('Please provide a password!')
  //     }
  //     else {
  //       alert('Please provide an email!')
  //     }
  //   }
  //   else if (this.tmpEnv.password.length < 8) {
  //     alert('Minimum Password length is Eight!')
  //   }

  //   if (this.selectUserEmail === 'Select Email') {



  //     alert(" Please select valid  email !")
  //   }


  //   // this.userService.saveUser(this.selectUserEmail,this.tmpEnv.password).pipe(first()).subscribe((res: any) => {
  //   if (this.tmpEnv.password.length >= 8) {

  //     this.userService.saveUser(this.selectUserEmail, this.tmpEnv.password)
  //       .pipe(
  //         first(),
  //         catchError((error: HttpErrorResponse) => {
  //           // Log the error message
  //           console.error('Error occurred:', error);

  //           // Check if the error message matches the condition
  //           if (error.error && error.error.status === 'Entered password same as current password') {
  //             // Show modal here
  //             this.modalRef = this.dialog.open(this.DuplicatePassword);
  //           }

  //           return throwError(error);
  //         })
  //       )
  //       .subscribe((res: any) => {




  // if (res.status == 'success') {
  //   this.modalRef = this.dialog.open(this.createdPassword)
  //      setTimeout(() => {
  //       this.modalRef.close();;
  //      }, 2000);
  //   this.tmpEnv.password = ''
  //   this.showCreateUser = false

  // }


  //       });

  //   }
  // }




  //for checking validation create User
  checkEmailValidity() {
    this.isEmailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.tmpEnv.userEmail);
    this.checkFormValidity();
  }

  //for checking validation create User
  checkNameValidity() {
    this.isNameValid = /^[\w\s]+$/.test(this.tmpEnv.userName);
    this.checkFormValidity();
  }

  checkPasswordValidity() {
    this.isPassword = this.tmpEnv.password.length >= 8 ? true : false;
    this.checkFormValidity();
  }

  //for checking validation create User
  checkFormValidity() {
    this.isFormValid = this.isEmailValid && this.isNameValid && this.isPassword;
  }

  //for All user Deleted
  removeUsers(search?: any, filteredUsers?: any, askConfirmation?: any) {
    this.cancelRequest();
    let removeUsers = () => {

      let emails = this.users.map((x) => x.email);



      this.userService.removeUsers(emails, this.removingFilters).pipe(first()).subscribe((res: any) => {
        this.users = this.users.filter((user) => user.privilege === "admin");

      });

      // this.users.forEach(user => {

      //   if (user.privilege !== 'admin') {
      //     ///eror not called 
      //     this.deleteUser(user.email, Date.now())
      //   }

      // })



      // this.deleteUser(emails,Date.now())
    }
    if (askConfirmation) {
      this.modalRef = this.dialog.open(this.removeAllTemplate);
    }
    else {
      removeUsers();
    }
  }
  //for one deleted user
  remove(email?: any) {

    this._email = email;
    this.modalRef = this.dialog.open(this.removeTemplate);
  }

  removeUser() {
    this.cancelRequest();
    let userToBeDeleted = this.users.filter(item => item.email == this._email)
    this.notifyUserUpdation.notifyUserDeleted(userToBeDeleted[0]);
    this.userService.removeUser(this._email, this.removingFilters).pipe(first()).subscribe((res: any) => {
      if (res.success == true || res.success == "true") {
        let Removedata = this.usersListByemail.filter(item => item !== this._email)
        this.usersListByemail = []
        this.usersListByemail = Removedata
        this.deleteUser(this._email, Date.now())
      }
    });
    // if (this.removingFilters.groupOwner !== 'True') {
    //   this.deleteUser(_email, Date.now())

    // } else {

    //   this.modalRef = this.dialog.open(this.fliterRemoveUser)
    // setTimeout(()=>{
    //   this.modalRef.close();;
    // },2000)
    // }




  }




  removeFilters() {
    this.removingFilters.groupOwner = "Any";
  }

  updateDefaultUserGroupsQuotas() {
    this.saveDefaultButtonDisable = true;
    this.userService.updateDefaultUserGroupsQuotas(this.tmpEnv.defaultGroupsNumber
      , this.tmpEnv.defaultGroupsDuration
      , this.tmpEnv.defaultGroupsRepetitions).pipe(first()).subscribe((rep: any) => {
        if (rep.success === true || rep.success === "true") {
          this.alertMessage = "successfully updated"
          this.modalRef = this.dialog.open(this.alertTemplate);
          setTimeout(() => {
            this.modalRef.close();;
          }, 2000)
        }
      });
  }

  updateUserGroupsQuotas(user) {
    this.saveButtonDisable = true;
    this.userService.updateUserGroupsQuotas(user.email, user.groupsNumber, user.groupsDuration, user.groupsRepetitions).pipe(first()).subscribe((rep: any) => {
      if (rep.success === true || rep.success === "true") {
        this.alertMessage = "successfully updated"
        this.modalRef = this.dialog.open(this.alertTemplate);
        setTimeout(() => {
          this.modalRef.close();;
        }, 2000)
        this.buttonColor = '#6d8f9d'
      }
    });
  }

  initTemporaryDefaultQuotas(): void {
    this.tmpEnv.defaultGroupsNumber = this.adminUser.groups.quotas.defaultGroupsNumber
    this.tmpEnv.defaultGroupsDuration = this.adminUser.groups.quotas.defaultGroupsDuration
    this.tmpEnv.defaultGroupsRepetitions = this.adminUser.groups.quotas.defaultGroupsRepetitions
    this.tmpEnv.defaultQuotasTooltip = 'No change'

  }

  initTemporaryQuotas(user) {
    user.groupsNumber = user.groups.quotas.allocated.number;
    user.groupsDuration = user.groups.quotas.allocated.duration;
    user.groupsRepetitions = user.groups.quotas.repetitions;
    user.quotasTooltip = 'No change';

    this.users.forEach((x) => {

      if (x.email == user.email) {

        if (x.isGroupsQuotasClicked == true) {
          x.isGroupsQuotasClicked = false;
        } else {
          x.isGroupsQuotasClicked = true;
        }
      } else {
        x.isGroupsQuotasClicked = false;
      }
    })
  }

  GroupsQuotasDefaultValueChnage() {
    this.saveDefaultButtonDisable = false;

  }
  GroupsQuotasValueChnage() {
    this.saveButtonDisable = false;
    if (!this.saveButtonDisable) {

      this.buttonColor = '#160624'
    }
  }

  enableAppInstall(email: any) {
    let value = true;
    this.automationService.setAppInstaller(email, value).pipe(first()).subscribe((rep: any) => {
      if (rep.success === true || rep.success === "true") {
        this.msg = "Successfully Updated";
        this.openAlertMod(this.alerttemplate, this.msg);
        // alert("successfully updated")

      }
      else {
        this.msg = "Successfully Updated";
        this.openAlertMod(this.alerttemplate, this.msg);
        // alert(rep.Message)
      }
    });
  }

  disableAppInstall(email: any) {
    let value = false
    this.automationService.setAppInstaller(email, value).pipe(first()).subscribe((rep: any) => {
      if (rep.success === true || rep.success === "true") {
        this.msg = "Successfully Updated";
        this.openAlertMod(this.alerttemplate, this.msg);
        // alert("successfully updated")

      }
      else {
        this.msg = rep.Message;
        this.openAlertMod(this.alerttemplate, this.msg);
        // alert(rep.Message)
      }
    });
  }

  cancelRequest() {
    this.modalRef.close();
  }

  CreateUser() {
    this.userService.showUserList().subscribe((resp: any) => {
      this.usersListByemail = resp.usersList;
    })
  }

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }

  toggleFieldTextType() {
    this.fieldTextType = !this.fieldTextType;
  }

  showCreate() {
    this.showCreateUser = !this.showCreateUser
  }

  openAlertMod(template: TemplateRef<any>, message: any) {
    this.modalRef = this.dialog.open(template, { width: '300px' });
    this.msg = message;
    setTimeout(() => {
      this.modalRef.close();;
      this.msg = '';
    }, 2000)
  }

  Ok() {
    this.modalRef.close();;
    this.msg = "";
  }

  toggleLock(user: any) {
    this.findemail = user.email;
    if (user.profileActiveStatus == true) {
      this.modalRef = this.dialog.open(this.blockedUser);
    } else {
      this.modalRef = this.dialog.open(this.unBlockedUser);
    }
  }
  BlockedUser() {

    this.userService.UserBlockUnblock(this.findemail, false).subscribe((resp: any) => {

      if (resp.success == true || resp.success == 'true') {
        this.modalRef = this.dialog.open(this.template)
        setTimeout(() => {
          this.modalRef.close();
        }, 2000)
      }
      this.users.forEach((data) => {
        if (data.email == this.findemail) {
          data.profileActiveStatus = false;
        }
      }
      )


    })

  }


  UnBlockedUser() {
    this.userService.UserBlockUnblock(this.findemail, true).subscribe((resp: any) => {

      if (resp.success == true || resp.success == 'true') {
        this.modalRef = this.dialog.open(this.template)
        setTimeout(() => {
          this.modalRef.close();
        }, 2000)
      }
      this.users.forEach((data) => {
        if (data.email == this.findemail) {
          data.profileActiveStatus = true;
        }
      })
    })
  }


  cancel() {
    this.modalRef.close();
  }
}



